import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    createTip,
    getTips,
    updateTip,
    deleteTip
}

function createTip(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/tips`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getTips(query) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/tips`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateTip(tipId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/tips/${tipId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteTip(tipId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/tips/${tipId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}